/* eslint-disable no-console */
/* eslint-disable no-undef */
import { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import { Button } from '@/ui/index';
import { OutlineLocation } from '@/icons/index';

import Filters from '../Filters/Filters';
import Maps from '../Map/Map';

import styles from './OfficesList.module.scss';

const Shop = ({ data, setTab = () => null }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const setLink = () => {
    setTab('map');
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          coords: `${data?.lat},${data?.lng}`,
        },
      },
      undefined,
      { shallow: true, scroll: true },
    );
  };
  return (
    <div
      className={`${styles.item} grid-extend`}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {!!data && (
        <div className={styles.col}>
          <div className={styles.label}>{data?.type_name_of_office}</div>
          <div className={`${styles.value} grid-extend`}>
            <div className={styles.title}>{data?.name}</div>
            <div>{data?.description}</div>
          </div>
        </div>
      )}

      <div className={styles.col}>
        {data?.working_hours?.length > 0 && (
          <>
            <div className={styles.label}>{t('common:workingHours')}</div>
            <div className={`${styles.value} grid-extend`}>
              {data?.working_hours?.map((item, index) => (
                <div className={`${styles.hours} grid-extend`} key={index}>
                  <span>
                    {item?.days}
                    {item?.working_hours && ':'}
                  </span>
                  <span>{item?.working_hours}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <div className={styles.col}>
        {data?.email && (
          <>
            <div className={styles.label}>{t('common:email')}</div>
            <div className={`${styles.value} grid-extend`}>
              <div>{data.email}</div>
            </div>
          </>
        )}
      </div>

      <div className={styles.col}>
        {data?.phone_number && (
          <>
            <div className={styles.label}>{t('common:phone')}</div>
            <div className={`${styles.value} grid-extend`}>
              <div>{data?.phone_number}</div>
            </div>
          </>
        )}
      </div>

      <div className={styles.col}>
        {data?.lat && data?.lng && (
          <Button onClick={setLink} className={`${styles.link} flex-c-c`}>
            <OutlineLocation />
          </Button>
        )}
      </div>
    </div>
  );
};

const OfficesList = ({ data }) => {
  const [tab, setTab] = useState('map');
  const [offices, setOffices] = useState();
  const router = useRouter();

  const city = router.query?.city;
  const officeType = router.query?.officeType;

  const filteredOffices = useCallback(
    (city, officeType) => {
      let filtered = data?.our_offices ?? [];
      if (city && city !== 'all') {
        filtered = data?.our_offices.filter(
          (office) => String(office.city_id) === String(city),
        );
      }
      if (officeType && officeType !== '0') {
        filtered = filtered.filter(
          (office) => String(office.office_type.id) === String(officeType),
        );
      }
      return filtered;
    },
    [data?.our_offices],
  );
  useEffect(() => {
    setOffices(data?.our_offices);
    if (!router.isReady) return;
    if (city || officeType) {
      setOffices(filteredOffices(city, officeType));
    }
  }, [data?.our_offices, router.isReady, filteredOffices, city, officeType]);

  const [customerLocation, setCustomerLocation] = useState({});

  const getCustomerLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          InfoWindowF.setPosition(pos);
          InfoWindowF.setContent('Location found.');
          InfoWindowF.open(map);
          map.setCenter(pos);
          setCustomerLocation(pos);
        },
        (error) => {
          console.log(error);
        },
      );
    } else {
      // Browser doesn't support Geolocation
      console.log('Browser does not support');
    }
  };

  return (
    !!data && (
      <div
        className={styles.wrap}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        <Filters
          cities={data?.cities}
          offices={data?.office_types}
          tab={tab}
          setTab={setTab}
          className={classNames([
            {
              [styles.filterWrap]: tab === 'list',
              [styles.filterWrapMap]: tab === 'map',
            },
          ])}
          gps={getCustomerLocation}
        />

        {tab === 'map' && (
          <div>
            <Maps markers={offices} />
          </div>
        )}
        {tab === 'list' && (
          <div>
            <div className={`${styles.listWrap} wrapper section`}>
              <div className={styles.list}>
                {offices?.map((item, index) => (
                  <Shop data={item} setTab={setTab} key={index} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default OfficesList;
